export default {
    access: "Access",
    accessDeniedHeader: "Access Denied",
    accessDeniedBody: "You have no access to this page",
    account: "Account",
    accounts: "Accounts",
    accountComplianceSets: "Account Compliance Sets (ACS)",
    accountDevice: "Account device",
    accountDevices: "Account devices",
    accountGroups: "Account Groups",
    accountManagement: "Account Management",
    accountSettings: "Account Settings",
    accountSubsystems: "Account Subsystems",
    achieved: "Achieved",
    achievedOrNot: "Achieved or not",
    actions: "Actions",
    active: "Active",
    activePackage: "Active Package",
    actual: "Actual",
    add: "Add",
    addAccount: "Add Account",
    addAccountPackage: "Add Account Package",
    addApprovalLevel: "Add Approval Level",
    addCategory: "Add Category",
    addChildObjective: "Add Child Objective",
    addComment: "Add comment",
    addCompany: "Add Company",
    addComplianceSet: "Add Compliance Set",
    addCompliantItem: "Add Compliant Item",
    addDataset: "Add Dataset",
    addDevice: "Add Device",
    addFailureMode: "Add Failure Mode",
    addFile: "Add File",
    addFile_s: "Add File(s)",
    addFolder: "Add Folder",
    addFromFile: "Add From File",
    addFromLexicon: "Add From Lexicon",
    addGroup: "Add Group",
    additionalCalculations: "Additional Calculations",
    addKeyResult: "Add Key Result",
    addLabel: "Add Label",
    addLevel: "Add Level",
    addLifecycle: "Add Life Cycle",
    addMethod: "Add Method",
    addMetric: "Add Metric",
    addModel: "Add Model",
    addModule: "Add Module",
    addObjective: "Add Objective",
    addObserver: "Add Observer",
    addObserver_s: "Add Observer(s)",
    addOption: "Add Option",
    addOwners: "Add Owners",
    addPackage: "Add Package",
    addParagraph: "Add Paragraph",
    addParticipant: "Add Participant",
    addParticipant_s: "Add Participant(s)",
    addPriority: "Add Priority",
    addProduct: "Add Product",
    addProject: "Add Project",
    addRedistribution: "Add Redistribution",
    addRequirement: "Add Requirement",
    addressedInRevision: "This will be addressed in revision",
    addResponse: "Add Response",
    addReview: "Add Review",
    addReviewItem: "Add Review Item",
    addSafetyFunction: "Add Safety Function",
    addSession: "Add Session",
    addSeveral: "Add Several",
    addSmartCompliance: "Add Smart Compliance",
    addStartvector: "Add Start Vector",
    addState: "Add State",
    addStatus: "Add Status",
    addStudy: "Add Study",
    addSubsystem: "Add Subsystem",
    addTag: "Add Tag",
    addTask: "Add Task",
    addTeamMember: "Add Team Member",
    addTemplate: "Add Template",
    addTransition: "Add Transition",
    addType: "Add Type",
    addUser: "Add User",
    addVariable: "Add Variable",
    agile_model: "Agile model",
    almostExpired: "Almost Expired",
    almostOverdue: "Almost Overdue",
    answer: "Answer",
    answerType: "Answer Type",
    anyDate: "Any Date",
    appendix: "Appendix",
    apply: "Apply",
    approvalLevel: "Approval Level",
    approvalLevels: "Approval Levels",
    approvalLevelsAccess: "Approval Levels Module Access",
    approved: "Approved",
    architecture: "Architecture",
    architecturalConstraints: "Architectural Constraints",
    architecturalConstraintsMissing: "Architectural constraints missing for one or more subsystems.",
    archived: "Archived",
    archivedSessionDescription: "The session is closed and no updates are possible",
    articleId: "Article ID",
    assign: "Assign",
    assignTo: "Assign To",
    assignedModules: "Assigned Modules",
    assignedUsers: "Assigned Users",
    attachment: "Attachment",
    attachments: "Attachments",
    attendance: "Attendance",
    authErrorDemoAccountExpired: "Your demo account is expired",
    authErrorNoAccount: "You don't have active accounts",
    authErrorNoPackage: "Your account has no package",
    authErrorNoUser: "You are not added to Business Master",
    authErrorPackageExpired: "Your account package is expired",
    authErrorWrongUsernamePassword: "Wrong username or password",
    author: "Author",
    average: "Average",
    aws: "AWS",
    awsStorage: "AWS Storage",
    back: "Back",
    baysian: "Baysian",
    beta: "Beta Factor",
    betaD: "Beta_D",
    billing: "Billing",
    biweekly: "Every two weeks",
    blocks: "Blocks",
    brand: "Brand",
    businessMaster: "Business Master",
    buy: "Buy",
    buyPackageMaxUsersError: "Your account has {0} users. You can't buy this package",
    byDateChanged: "By date changed",
    byId: "By ID",
    byName: "By name",
    cadence: "Cadence",
    cadenceDescription: "Set how often Key Results should be updated.",
    cancel: "Cancel",
    cancelOrder: "Cancel Order",
    calculate: "Calculate",
    calculateAll: "Calculate All",
    calculated: "Calculated",
    calculatedSafetyFunctions: "Calculated Safety Function(s)",
    calculation: "Calculation",
    calculationAssumptions: "Calculation Assumptions",
    calculations: "Calculations",
    calculationCost: "It will cost {0} calculation(s).",
    calculationMethod: "Calculation Method",
    calculationMethodDangerous: "Calculation Method Dangerous",
    calculationMethodSafe: "Calculation Method Safe",
    capable: "Capable",
    cart: "Cart",
    cartEmpty: "Your cart is currently empty!",
    categories: "Categories",
    category: "Category",
    categoryUsedIn: "The Category you are about to delete is used in:",
    ccComplianceReport: "Compliance Case",
    ccFixComplianceAnswer: "Fix Compliance Answer",
    ccReviewComplianceReport: "Review Compliance Case",
    ccRequirementsReviewReport: "Requirements Review",
    change: "Change",
    changeCreator: "Change Creator",
    changeManager: "Change Manager",
    changeOwner: "Change Owner",
    changePassword: "Change Password",
    changeResponsible: "Change Responsible",
    changeUpgradeSubscription: "Change/Upgrade subscription",
    checkAndConfirmEmail: "Please check your email (including your spam folder) and confirm your email address.",
    checkEmailAndResetPassword: "Please check your email (including your spam folder) and reset password.",
    checkout: "Checkout",
    children: "Children",
    childCategoriesRequired: "This category has no children.",
    clear: "Clear",
    clickConfirm: "Click again to confirm",
    clickConfirmDelete: "Click again to delete",
    clickEnterToConfirm: "Click 'Enter' to confirm",
    clone: "Clone",
    close: "Close",
    cloudDrivesAllowed: "Cloud Drives Allowed",
    cloudDrivesWillBeNotAvailable: "After this cloud drive is connected, the rest cloud drives will not be available anymore.",
    cloudDriveConfirmLink: "Visit {0} and enter result code into the form below.",
    color: "Color",
    comment: "Comment",
    comments: "Comments",
    companies: "Companies",
    company: "Company",
    companyName: "Company Name",
    competence: "Competence",
    complete: "Complete",
    completed: "Completed",
    compliance: "Compliance",
    complianceCaseAccess: "Compliance Case Access",
    complianceSet: "Compliance Set",
    complianceSetDescription: "Compliance Set Description",
    complianceSets: "Compliance Sets",
    complianceSetsReport: "The following compliance sets are a part of this project:",
    compliant: "Compliant",
    compliantItem: "Compliant Item",
    compliantItems: "Compliant Items",
    compliantItemsPerSet: "Compliant Items per Set",
    confidence: "Confidence",
    confidenceLevel: "Confidence Level",
    configuration: "Configuration",
    confirm: "Confirm",
    confirmCalculation: "Confirm Calculation",
    confirmCode: "Confirm Code",
    confirmCompliance: "After confirm you will not be able to add changes. Continue?",
    confirmDeleteDatapoints: "Do you want to delete all datapoints from there?",
    confirmDeleteDataset: "Do you want to delete this dataset?",
    confirmDeleteSetFromCompliance: "Do you want to delete this set from Compliance? All history will be removed",
    confirmDeleteSetFromReview: "Do you want to delete this set from Review? All history will be removed",
    confirmDeleteRedistribution: "Do you want to delete this redistribution?",
    confirmDeleteReviewDocument: "Do you want to delete this document from Review?",
    confirmDeleteRevision: "Do you want to delete this revision?",
    confirmDeleteStartvector: "Do you want to delete this start vector?",
    confirmDeletionTitle: "Confirm deletion",
    confirmDeletionDescription: "Do you want to move the selected items to Recycle Bin, or delete it irreversibly?",
    confirmDeletionRecycleDescription: "Do you want to delete the selected items permenantly?",
    confirmMoveTitle: "Move the selected items to folder",
    confirmRestoreTitle: "Confirm restore",
    confirmRestoreDescription: "Do you want to restore the selected items?",
    conflictsWithHardDeadline: "Conflicts with hard deadline of Key Results",
    conflictsWithHardDeadlineDescription: `
        The Key Results below have a hard deadline that is outside of the session's timeframe.
        You can edit the Key Results or ignore these conflicts.
        If you ignore the conflicts, the hard deadline will be set to the last day of the session.
    `,
    conflictsWithSoftDeadline: "Conflicts with soft deadline of Key Results",
    conflictsWithSoftDeadlineDescription: `
        The Key Results below have a soft deadline that is outside of the session's timeframe.
        You can edit the Key Results or ignore these conflicts.
        If you ignore the conflicts, the soft deadline will be set to one day before the session's end date.
    `,
    conflictsWithUpdate: "There are some conflicts with this update",
    connect: "Connect",
    connectDriveStep1SetCredentials: "Step 1: set credentials",
    connectDriveStep2EnterConfirmCode: "Step 2: enter confirm code",
    connectionFailed: "Connection Failed",
    contactToPurchase: "Contact us to purchase the desired package",
    content: "Content",
    copy: "Copy",
    copyAll: "Copy All",
    copiedToClipboard: "Copied to clipboard",
    copyDevice: "Copy this Device to account or to specific project?",
    copyOkrsIn: "Copy OKRs in",
    copyright: "Copyright",
    copyrightFooter: "Copyright \u00A9 {year} Risknowlogy. All Rights Reserved.",
    copySafetyFunction: "Copy this Safety Function to specific project?",
    copySubsystem: "Copy this Subsystem to account or to specific project?",
    cost: "Cost",
    createEmptyFile: "Create Empty File",
    created: "Created",
    createdAt: "Created At",
    createdBy: "Created By",
    creator: "Creator",
    createCustomUnit: "Create a custom unit",
    createFile: "Create file",
    createFolder: "Create folder",
    createFromSearch: "Create from Search...",
    createSubtask: "Create Subtask",
    createTask: "Create Task",
    credentials: "Credentials",
    credentialsApplicationClientId: "Application (client) ID",
    credentialsClientSecret: "Client Secret",
    criticalNumber: "Critical Number",
    criticalNumberDescription: "The additional critical target is optional.",
    criticalNumberLowerTarget: "The critical value should be lower than the target",
    criticalNumberGreaterTarget: "The critical value should be greater than the target",
    current_day: "Current day",
    currentDevice: "Current Device",
    currentProgressAt: "current progress at",
    currentSubsystem: "Current Subsystem",
    currentValue: "Current Value",
    custom_range: "Custom range",
    customizable: "Customizable",
    customVariables: "Custom Variables",
    dangerousFailures: "Dangerous Failures",
    dangerousSystematicFailure: "Dangerous Systematic Failure",
    dashboard: "Dashboard",
    datapoint: "Datapoint",
    datapointReference: "Datapoint Reference",
    datasets: "Datasets",
    date: "Date",
    dateEnd: "Date End",
    dateEndEqualDateStart: "Date End can not be equal to Date Start",
    dateEndLessDateStart: "Date End can not be less than Date Start",
    dateOfUpdate: "Date Of Update",
    dateStart: "Date Start",
    days: "days",
    daysLeft: "Days left",
    daysLeftWarning: "Warning! Package you want to upgrade/downgrade is expired!",
    dc: "DC",
    dcCalculated: "DC calculated",
    dcGiven: "DC given",
    dcOf: "DC of",
    dd: "DD",
    ddOf: "DD of",
    de: "German",
    deadline: "Deadline",
    deadlineOkrDescription: `If you wish, you can choose a custom deadline. The default deadline for the KR is the end of this session.
        After the deadline, you will no longer be able to update this KR.
    `,
    decimal: "Decimal",
    decryptionFailed: "Impossible to decrypt. Wrong secret key",
    default: "Default",
    defaultArchitecturalConstraints: "Default Architectural Constraints",
    defaultAssignedModules: "Default Assigned Modules",
    defaultAssumption: "Default Assumption",
    defaultBeta: "Default Beta Factor",
    defaultBetaD: "Default Beta_D",
    defaultCalculationMethod: "Default Calculation Method",
    defaultDangerousSystematicFailure: "Default Dangerous Systematic Failure",
    defaultDescription: "Default Description",
    defaultDI: "Default DI",
    defaultGroups: "Default Groups",
    defaultIec_61508_2010_settings: "Default IEC 61508:2010 Settings",
    defaultIec_61508_1998_settings: "Default IEC 61508:1998 Settings",
    defaultIsa_tr84_2002_settings: "Default ISA TR84:2002 Settings",
    defaultIsa_tr84_2022_settings: "Default ISA TR84:2022 Settings",
    defaultImage: "Default Image",
    defaultK: "Default K",
    defaultMode: "Default Mode",
    defaultMttr: "Default MTTR",
    defaultMrt: "Default MRT",
    defaultName: "Default Name",
    defaultPtc0A: "Default PTC 0, A",
    defaultPtc1A: "Default PTC 1, A",
    defaultPtc0B: "Default PTC 0, B",
    defaultPtc1B: "Default PTC 1, B",
    defaultPtc0C: "Default PTC 0, C",
    defaultPtc1C: "Default PTC 1, C",
    defaultPublicId: "Default Public ID",
    defaultSafeSystematicFailure: "Default Safe Systematic Failure",
    defaultSafetyFunctionName: "Default Safety Function Name",
    defaultSessionCadence: "Default Session Cadence",
    defaultSessionDuration: "Default Session Duration",
    defaultSessionStartDate: "Default Session Start Date",
    defaultStorage: "Default storage",
    defaultT0: "Default T0",
    defaultT1: "Default T1",
    defaultT2: "Default T2",
    defaultTI: "Default TI",
    defaultTemplate: "Default Template:",
    defaultValue: "Default Value",
    defaultVdiVde_2180_2019_settings: "Default VDI/VDE 2180:2019 Settings",
    defer: "Defer",
    deferred: "Deferred",
    delegate: "Delegate",
    delegateTo: "Delegate To",
    delete: "Delete",
    deleteAttachment: "Delete attachment",
    deleteCategoryConfirm: "Delete this category?",
    deleteCategoryNested: "Delete nested categories",
    deleteChildItems: "Delete child items",
    deleteCommentConfirm: "Delete this comment?",
    deleteConnectionConfirm: "Delete this connection?",
    deleteCredentialsConfirm: "Delete credentials?",
    deleteFailureModeConfirm: "Delete this failure mode?",
    deleteFailureModeDatapointsConfirm: `
        There are one or more data points assocaited with this failure mode.
        Deleting the failure mode will also delete the data point(s). Are you sure?
    `,
    deleteItemConfirm: "Delete this item?",
    deleteIrreversibly: "Delete Irreversibly",
    deleteKeyResultConfirm: "Delete this key result?",
    deleteKeyResultUpdateConfirm: "Delete Key Result update?",
    deleteLabelConfirm: "Delete this label?",
    deleteModelConfirm: "Delete this model?",
    deleteModelDatapointsConfirm: `
        There are one or more data points assocaited with this model.
        Deleting the model will also delete the data point(s). Are you sure?
    `,
    deleteObjectiveConfirm: "Delete this objective?",
    deleteOptionConfirm: "Delete this option?",
    deleteOptionDatapointsConfirm: `
        There are one or more data points assocaited with this option.
        Deleting the option will also delete the data point(s). Are you sure?
    `,
    deleteParagraphConfirm: "Delete this paragraph?",
    deletePhaseConfirm: "Delete this phase?",
    deleteSafetyFunctionConfirm: "Delete this safety function?",
    deleteSafetyFunctionDatapointsConfirm: `
        There are one or more data points assocaited with this safety function.
        Deleting the safety function will also delete the data point(s). Are you sure?
    `,
    deleteSessionConfirm: "Delete this session?",
    deleteStartvectorStateConfirm: "Delete data for this Start Vector state?",
    deleteTaskConfirm: "Delete this task?",
    deleteVariableConfirm: "Delete this variable?",
    demo: "Demo",
    demoExpired: "Demo Expired",
    department: "Department",
    description: "Description",
    deselectAll: "Deselect All",
    details: "Details",
    detectedFailuresLeadToDangerousState: "Safe detected failures lead to dangerous state?",
    detectedFailuresLeadToSafeState: "Detected failures lead to safe state?",
    device: "Device",
    devices: "Devices",
    deviceDetails: "The device has a given",
    deviceDetailsByUser: "Device details entered by the user",
    deviceMode: "A {0} device",
    deviceType: "A Type {0} device",
    deviceUpdated: `The Account Device was updated.
        Click {0} if you wish to review the difference(s) between the Account Device and the Project Device.`,
    devicesUpdated: `The Account Devices used in this project were updated.
        Please view {0} to review the list of Devices, and {0} to review the list of Subsystems`, // "{0}" is used for "split" function
    di: "DI",
    displayAfterNumber: "Display after number",
    displayBeforeNumber: "Display before number",
    d_f: "D_F",
    document: "Document",
    documentId: "Document ID",
    documents: "Documents",
    doubleEnd: "Double End",
    downgrade: "Downgrade",
    download: "Download",
    drafts: "Drafts",
    draftSaved: "Draft saved",
    drive: "Drive",
    drivePathNotExist: "The path does not exist",
    driveSpace: "Drive Space",
    driveSpaceGB: "Drive Space, GB",
    du: "DU",
    duOf: "DU of",
    duration: "Duration",
    edit: "Edit",
    editable: "Editable",
    editAccount: "Edit Account",
    editAccountPackage: "Edit Account Package",
    editAnswer: "Edit Answer",
    editApprovalLevel: "Edit Approval Level",
    editCalculationAssumptions: "Edit Calculation Assumptions",
    editCategory: "Edit Category",
    editCompany: "Edit Company",
    editComplianceSet: "Edit Compliance Set",
    editCompliantItem: "Edit Compliant Item",
    editDataset: "Edit Dataset",
    editDevice: "Edit Device",
    editFailureMode: "Edit Failure Mode",
    editFailureRates: "Edit Failure Rates",
    editFile: "Edit File",
    editGroup: "Edit Group",
    editKeyResult: "Edit Key Result",
    editKeyResultUpdate: "Edit KR Update",
    editLabel: "Edit Label",
    editLevel: "Edit Level",
    editLifecycle: "Edit Life Cycle",
    editLifecyclePhases: "Edit Life Cycle Phases",
    editLifecycles: "Edit Life Cycles",
    editMethod: "Edit Method",
    editMetric: "Edit Metric",
    editModel: "Edit Model",
    editModule: "Edit Module",
    editObjective: "Edit Objective",
    editOption: "Edit Option",
    editPackage: "Edit Package",
    editParagraph: "Edit Paragraph",
    editPriority: "Edit Priority",
    editProduct: "Edit Product",
    editProfile: "Edit Profile",
    editProject: "Edit Project",
    editRedistribution: "Edit Redistribution",
    editRedistributionState: "Edit Redistribution State",
    editRequirement: "Edit Requirement",
    editResponse: "Edit Response",
    editRevision: "Edit Revision",
    editReviewItem: "Edit Review Item",
    editRiskRank: "Edit Risk Rank",
    editSafetyFunction: "Edit Safety Function",
    editSession: "Edit Session",
    editSmartCompliance: "Edit Smart Compliance",
    editStartvector: "Edit Start Vector",
    editStartvectorState: "Edit Start Vector State",
    editState: "Edit State",
    editStatus: "Edit Status",
    editStudy: "Edit Study",
    editSubsystem: "Edit Subsystem",
    editTag: "Edit Tag",
    editTask: "Edit Task",
    editTeamMember: "Edit Team Member",
    editTemplate: "Edit Template",
    editTransition: "Edit Transition",
    editType: "Edit Type",
    editUser: "Edit User",
    editVariable: "Edit Variable",
    email: "Email",
    emailConfirmed: "Email Confirmed!",
    emailSent: "Email Is Sent",
    empty: "Empty",
    emptyBlocksNotAllowed: "Empty blocks are not allowed",
    emptyFolder: "There are no files or folders in this folder",
    emptyRecycleBin: "Empty Recycle Bin",
    emptyRecycleBinConfirm: "Are you sure you want to delete all items from the Recycle Bin irreversibly?",
    emptySubsystemNameNotAllowed: "Subsystems with empty name are not allowed",
    en: "English",
    endTime: "End Time",
    enterComplianceAnswerUrl: "Enter compliance answer URL",
    es: "Spanish",
    everyDayX: "Every {0}",
    exact_date: "Exact date",
    execute: "Execute",
    existingSubsystem: "Existing subsystem",
    expired: "Expired",
    expiredOn: "Expired on {0}",
    expiresOn: "Expires on {0}",
    expiryDate: "Expiry Date",
    export: "Export",
    expression: "Expression",
    facilitator: "Facilitator",
    failed: "Failed",
    failureMode: "Failure Mode",
    failureModes: "Failure Modes",
    failureRateFields: "Failure Rate Fields",
    failureRateSD: "Failure Rate SD",
    failureRateSU: "Failure Rate SU",
    failureRateDD: "Failure Rate DD",
    failureRateDU: "Failure Rate DU",
    failuresPerHour: "failures per hour",
    file: "File",
    files: "Files",
    fileType: "File Type",
    fillInGivenFailureRates: "Fill in Given Failure Rates",
    fillInGivenSFF: "Fill in Given SFF/DC/PFDavg/PFH/SIL",
    finish: "Finish",
    firstDayOfMonth: "First day of month",
    first_day_of_month: "On the first day of the month",
    firstName: "First Name",
    fit: "FIT",
    fitX: "{0} FIT",
    friday: "Friday",
    formal: "Formal",
    format: "Format",
    forgotPassword: "Forgot Password?",
    forgotPasswordDescription: "Enter your email address to reset your password",
    fr: "French",
    free: "Free",
    getStarted: "Get Started",
    givenFailureRates: "Given Failure Rates",
    givenSFF: "Given SFF/DC/PFDavg/PFH/SIL",
    givenSil: "SIL {0} according to user input - not verified",
    google: "Google",
    googleDrive: "Google Drive",
    googleDriveConnected: "Google Drive is connected. Do you want to update secrets or delete?",
    googleDriveNotConnected: "You have no connected Google Drive. Do you want to connect?",
    googleDriveSecrets: "Google Drive Secrets",
    googleStorage: "Google Storage",
    goToLogin: "Go to Login",
    group: "Group",
    groups: "Groups",
    halfYear: "Half year",
    hardDeadline: "Hard deadline",
    hardDeadlineDescription: "Date after which the KR cannot be updated",
    hardDeadlineForKeyResult: "The hard deadline for this Key Result is {0}",
    hardSoftDeadline: "Hard and soft deadline",
    hardSoftDeadlineDescription: `After the soft deadline, the new progress will be discounted proportionally
        for each lapsed day until the hard deadline`,
    hardwareFailureRateYes: "Based on the architectural constraints and the given failure rates the hardware of this device is",
    hardwareFailureRateNo: "Based on the architectural constraints and the given SFF/DC/PFDavg/PFH/STR the hardware of this device is",
    hideComments: "Hide comments",
    hidePrevious: "Hide Previous",
    high: "High",
    highPriority: "High Priority",
    history: "History",
    help: "Help",
    here: "here",
    home: "Home",
    hours: "hours",
    hoursLabel: ", hours",
    id: "Id",
    iec_61508_2010: "IEC 61508:2010",
    iec_61508_1998: "IEC 61508:1998",
    iec_61511_2016: "IEC 61511:2016",
    iec_61511_2003: "IEC 61511:2003",
    isa_tr84_2002: "ISA TR84:2002",
    isa_tr84_2022: "ISA TR84:2022 beta",
    ignoreAndUpdate: "Ignore and update",
    image: "Image",
    imageType: "Image Type",
    import: "Import",
    imported: "Imported",
    importComplianceSets: "Import Compliance Sets",
    importFromFile: "Import From File",
    importLifecycles: "Import Life Cycles",
    inactive: "Inactive",
    infiniteRecursion: "* found infinite recursion *",
    initial: "Initial",
    initialNumber: "Initial Number",
    initialNumberDescription: "This is the starting point from which your KR will be measured.",
    initialNumberLowerTarget: "The initial value should be lower than the target",
    initialNumberGreaterTarget: "The initial value should be greater than the target",
    insertIntoText: "Insert into text",
    inspector: "Inspector",
    insufficientData: "Insufficient Data",
    interpretation: "Interpretation",
    inProgress: "In Progress",
    inProgressSessionDescription: "Users can only update their KRs and cannot add new ones",
    in_progress: "In progress",
    inputDocuments: "Input Documents",
    it: "Italian",
    item: "Item",
    itemType: "Item Type",
    k: "K",
    keyResult: "Key Result",
    keyResultHardDeadlineDate: "by {0}",
    keyResultHardDeadlineDaysAgo: "{0} days ago",
    keyResultHardDeadlineDaysLeft: "{0} days left",
    keyResultNeverUpdated: "This Key Result has never been updated.",
    keyResultNeverUpdatedDescription: "Even if there is no progress, you can post an update.",
    keyResultOwner: "Key Result Owner",
    keyResultSoftDeadlineDescription: "the soft deadline is {0}",
    keyResults: "Key Results",
    keyResultTitleDescription: `The title will be the most visible part of your KR and it should be unambiguous and
        self-explanatory. There shouldn't be any doubt how you measure what you want to achieve.
    `,
    keyResultType: "Key Result Type",
    keyResultTypeDescription: `The Key Result type is needed to determine how progress is measured. Please choose
        the type that suits best your Key Result. The 'should stay above/below' types allow you to include an additional
        critical target.
    `,
    kind: "Kind",
    labels: "Labels",
    last_7_days: "Last 7 days",
    last_30_days: "Last 30 days",
    last_60_days: "Last 60 days",
    last_90_days: "Last 90 days",
    last_day_of_month: "On the last day of the month",
    lastName: "Last Name",
    leftCalculations: "You have {0} out of {1} calculation(s).",
    leftCalculationsHeader: "{0} out of {1} SIL calculation(s).",
    levels: "Levels",
    lexicon: "Lexicon",
    library: "Library",
    libraryComplianceSets: "Library Compliance Sets (LCS)",
    librarySetAddedToCart: "{0} is added to the cart",
    lifecycle: "Life Cycle",
    lifecycles: "Life Cycles",
    lifecycleAccess: "Life Cycle Manager Access",
    lifecyclePermissions: "Life Cycle Permissions",
    lifecyclePhase: "Life Cycle Phase",
    lifecyclePhases: "Life Cycle Phases",
    list: "List",
    load: "Load",
    location: "Location",
    locked: "Locked",
    logicSolver: "Logic Solver PE",
    logicSolverNo: "Not a PE Logic Solver",
    logicSolverYes: "A PE Logic Solver",
    login: "Login",
    logo: "Logo",
    lostServerConnection: "Server connection is lost. Reload the page",
    low: "Low",
    mail: "Mail",
    mainSettings: "Main Settings",
    manage: "Manage",
    manager: "Manager",
    manufacturer: "Manufacturer",
    markov: "Markov",
    markovModuleAccess: "Markov Module Access",
    markToDelete: "Mark to delete",
    maxAccountDevices: "Max number of account devices ({0})",
    maxAccountDevicesReached: "Max number of account devices ({0}) is reached",
    maxAccountDevicesExceeded: "Max number of account devices ({0}) is exceeded",
    maxAccountDevicesUnlimited: "Max number of account devices is unlimited",
    maxAccountUsers: "Max number of account users ({0})",
    maxAccountUsersReached: "Max number of account users ({0}) is reached",
    maxAccountUsersExceeded: "Max number of account users ({0}) is exceeded",
    maxAccountSets: "Max number of account sets ({0})",
    maxAccountSetsReached: "Max number of account sets ({0}) is reached",
    maxAccountSetsExceeded: "Max number of account sets ({0}) is exceeded",
    maxAccountSetsUnlimited: "Max number of account sets is unlimited",
    maxAccountSubsystems: "Max number of account subsystems ({0})",
    maxAccountSubsystemsReached: "Max number of account subsystems ({0}) is reached",
    maxAccountSubsystemsExceeded: "Max number of account subsystems ({0}) is exceeded",
    maxAccountSubsystemsUnlimited: "Max number of account subsystems is unlimited",
    maxLibrarySets: "Max number of imported sets ({0})",
    maxLibrarySetsReached: "Max number of imported sets ({0}) is reached",
    maxLibrarySetsExceeded: "Max number of imported sets ({0}) is exceeded",
    maxLibrarySetsUnlimited: "Max number of imported sets is unlimited",
    maxLibraryItems: "Number of custom compliant items is limited, based on your package, to {0} items. You have: {1}",
    maxLibraryItemsNone: "Custom compliant items are not allowed based on your package",
    maxLibraryItemsReached: "Max amount of compliant items is reached for this set",
    maxLifecycles: "Max number of account life cycles ({0})",
    maxLifecyclesReached: "Max number of account life cycles ({0}) is reached",
    maxLifecyclesExceeded: "Max number of account life cycles ({0}) is exceeded",
    maxLifecyclesUnlimited: "Max number of account life cycles is unlimited",
    maxSafetyFunctions: "Max number of safety functions ({0})",
    maxSafetyFunctionsReached: "Max number of safety functions ({0}) is reached",
    maxSafetyFunctionsExceeded: "Max number of safety functions ({0}) is exceeded",
    maxSafetyFunctionsUnlimited: "Max number of safety functions is unlimited",
    maxSubLifecycles: "Max number of sub-lifecycles ({0})",
    maxSubLifecyclesReached: "Max amount of sub-lifecycles ({0}) is reached for this lifecycle",
    maxSubLifecyclesExceeded: "Max amount of sub-lifecycles ({0}) is exceeded for this lifecycle",
    maxSubLifecyclesUnlimited: "Max amount of sub-lifecycles is unlimited",
    maxProjects: "Max number of projects ({0})",
    maxProjectsReached: "Max number of projects ({0}) is reached",
    maxProjectsExceeded: "Max number of projects ({0}) is exceeded",
    maxProjectsUnlimited: "Max number of projects is unlimited",
    maxRequirements: "Max number of requirements ({0})",
    maxRequirementsReached: "Max number of requirements ({0}) is reached",
    maxRequirementsExceeded: "Max number of requirements ({0}) is exceeded",
    maxRequirementsUnlimited: "Max number of requirements is unlimited",
    maxTeamMembers: "Max number of team members ({0})",
    maxTeamMembersReached: "Max number of team members ({0}) is reached",
    maxTeamMembersExceeded: "Max number of team members ({0}) is exceeded",
    maxTeamMembersUnlimited: "Max number of projects is unlimited",
    maxRrsTemplates: "Max number of templates ({0})",
    maxRrsTemplatesReached: "Max number of templates ({0}) is reached",
    maxRrsTemplatesExceeded: "Max number of templates ({0}) is exceeded",
    maxRrsTemplatesUnlimited: "Max number of templates is unlimited",
    medium: "Medium",
    method: "Method",
    metric: "Metric",
    metrics: "Metrics",
    microsoft: "MS OneDrive",
    microsoftOneDrive: "MS OneDrive",
    microsoftOneDriveConnected: "MS OneDrive is connected. Do you want to update secrets or delete?",
    microsoftOneDriveNotConnected: "You have no connected MS OneDrive. Do you want to connect?",
    microsoftOneDriveSecrets: "MS OneDrive Secrets",
    microsoftOneDriveStorage: "MS OneDrive Storage",
    minutes: "Minutes",
    mode: "Mode",
    modeContinuous: "Continuous",
    modeHighDemand: "High demand",
    modeLowDemand: "Low demand",
    model: "Model",
    models: "Models",
    modes: "Modes",
    modesNotTheSame: "Modes are not the same",
    modified: "Modified",
    module: "Module",
    modules: "Modules",
    moduleSettings: "Module Settings",
    monday: "Monday",
    month_0: "January",
    month_1: "February",
    month_2: "March",
    month_3: "April",
    month_4: "May",
    month_5: "June",
    month_6: "July",
    month_7: "August",
    month_8: "September",
    month_9: "October",
    month_10: "November",
    month_11: "December",
    monthShort_0: "Jan",
    monthShort_1: "Feb",
    monthShort_2: "Mar",
    monthShort_3: "Apr",
    monthShort_4: "May",
    monthShort_5: "Jun",
    monthShort_6: "Jul",
    monthShort_7: "Aug",
    monthShort_8: "Sep",
    monthShort_9: "Oct",
    monthShort_10: "Nov",
    monthShort_11: "Dec",
    monthly: "Monthly",
    months: "months",
    more: "More...",
    more_no_dots: "More",
    move: "Move",
    moveToRecycleBin: "Move To Recycle Bin",
    mrt: "MRT",
    mttf: "MTTF",
    mttfHours: "MTTF hours",
    mttfXHours: "MTTF {0} hours",
    mttfYears: "MTTF years",
    mttfXYears: "MTTF {0} years",
    mttr: "MTTR",
    multiple: "Multiple",
    mustBeAbove: "and absolutely must be above",
    mustBeBelow: "and absolutely must be below",
    myDrive: "My Drive",
    myFiles: "My files",
    myProjects: "My Projects",
    n_a: "N.A.",
    n_u: "N.U.",
    name: "Name",
    ne: "NE",
    nested: "Nested",
    nextPage: "Next",
    new: "New",
    newFolder: "New Folder",
    newName: "New Name",
    newPassword: "New Password",
    newValue: "New Value",
    no: "No",
    no_architectural_constraints: "No Architectural Constraints", // required as index
    noAccessToAddDevice: "You have no access to add a device here",
    noAccessToAddObjective: "You have no access to add an objective here",
    noAccessToAddSafetyFunction: "You have no access to add a safety function here",
    noAccessToAddSubsystem: "You have no access to add a subsystem here",
    noAccessToAddTask: "You have no access to add a task here",
    noArchitecturalConstraints: "No Architectural Constraints",
    noCopyright: "Copyright can not be displayed",
    noCustomDeadline: "No custom deadline",
    noCustomDeadlineDescription: "End of session",
    noDangerousFailure: "No dangerous failure calculation",
    noDatapoints: "No datapoints",
    noDeadline: "No deadline",
    noDeviceAdded: "No Device added",
    noDriveConnected: "No Drive connected",
    noLifecycles: "No Life Cycles added",
    none: "None",
    non_public: "Non public",
    nonPublic: "Non public",
    noReviewItems: "No Review Items",
    noSafeFailure: "No safe failure calculation",
    noSafetyFunctions: "There are no safety functions to display",
    noSelection: "No Selection",
    noSubsystemAdded: "No Subsystem added",
    notAchieved: "Not achieved",
    notAchievedYet: "Not achieved yet",
    notAllDevicesLogicSolvers: "(Not) all devices are logic solvers",
    notAllDevicesProvenInUse: "(Not) all devices are 'Proven in Use / Prior Use'",
    notAllowed: "Not Allowed",
    noTargetSet: "No target set",
    notApplicable: "Not Applicable",
    notApproved: "Not Approved",
    notAssigned: "Not Assigned",
    notAvailable: "Not Available",
    notCalculated: "Not Calculated",
    notCompliant: "Not Compliant",
    note: "Note",
    notFoundHeader: "Not Found",
    notFoundBody: "This page doesn't exists",
    notGiven: "Not Given",
    notProvenInUse: "Not 'Proven in Use / Prior Use'",
    notSet: "Not Set",
    notStarted: "Not Started",
    notUsed: "Not Used",
    np: "NP",
    number: "Number",
    objective: "Objective",
    objectiveOwner: "Objective Owner",
    objectives: "Objectives",
    objectivesKeyResults: "Objectives and Key Results",
    observers: "Observers",
    okr: "OKR",
    okrModuleAccess: "OKR Module Access",
    oldPassword: "Old Password",
    oldPasswordWrong: "Old password is wrong",
    onDayX: "On {0}",
    oneQuarter: "1 quarter",
    oneYear: "1 year",
    option: "Option",
    optionalField: "This field is optional",
    options: "Options",
    open: "Open",
    openSessionDescription: "Users can create, delete and edit OKRs",
    order: "Order",
    original: "Original",
    originDevice: "Origin Device",
    originSubsystem: "Origin Subsystem",
    orthogonal: "Orthogonal",
    other: "Other",
    outcomeAchieved: "Outcome achieved",
    outcomeNotAchieved: "Did not achieve the desired outcome yet",
    outputDocuments: "Output Documents",
    owner: "Owner",
    owners: "Owners",
    overdue: "Overdue",
    overview: "Overview",
    package: "Package",
    packageCalculations: "Package Calculations",
    packageDuration: "1 Year",
    packageExpired: "Package Expired",
    packages: "Packages",
    packageMaxUsers: "Max Users Count",
    packageUpgraded: "Upgraded from",
    packageDowngraded: "Downgraded from",
    pageOf: "Page {0} of {1}",
    parent: "Parent",
    parentCategory: "Parent Category",
    parentItem: "Parent Item",
    parentKeyResult: "Parent Key Result",
    parentObjective: "Parent Objective",
    parentParagraph: "Parent Paragraph",
    parents: "Parents",
    parentSession: "Parent session",
    parentSessionDescription: "Align this session to another one with a longer timeframe or a higher importance.",
    parentTask: "Parent Task",
    partial: "Partial",
    participants: "Participants",
    password: "Password",
    passwordChanged: "Password successfully changed!",
    passwordMismatch: "Password mismatch",
    passwordPlaceholder: "password",
    passwordRestrictions: `Password must contain letters, numbers, special symbols
        (,.<>/?;:'"[]{}\\|\`~!@#$%^&*()_+=-) and be at least 8 characters`,
    pause: "Pause",
    pay: "Pay",
    payForSubscription: "Pay for subscription",
    paymentMethod: "Payment Method",
    paymentProcessing: "Your payment is processing.",
    paymentSucceeded: "Payment succeeded!",
    paymentRequiresPaymentMethod: "Your payment was not successful, please try again.",
    paymentDefault: "Something went wrong.",
    pending: "Pending",
    pendingReview: "Pending Review",
    pending_review: "Pending review",
    percentageFields: "Percentage Fields",
    periodic: "Periodic",
    permissions: "Permissions",
    pfd: "PFDavg",
    pfdOf: "PFDavg of",
    pfdTargetIsMet: "PFDavg Target {0} is met",
    pfdTargetIsNotMet: "PFDavg Target {0} is not met",
    pfh: "PFH",
    pfhOf: "PFH of",
    pfhTargetIsMet: "PFH Target {0} is met",
    pfhTargetIsNotMet: "PFH Target {0} is not met",
    phaseList: "Phase List",
    phone: "Phone",
    plant: "Plant",
    populate: "Populate",
    postponed: "Postponed",
    postUpdate: "+ Post an update",
    present: "Present",
    previousComments: "Previous comments",
    prevPage: "Previous",
    price: "Price",
    priority: "Priority",
    priorUse: "Prior Use",
    private: "Private",
    probabilityFields: "Probability Fields",
    proceedToCheckout: "Proceed to checkout",
    product: "Product",
    products: "Products",
    profile: "Profile",
    progress: "Progress",
    project: "Project",
    projectLevelAlreadyHasDevice: `Project level already has a device referenced to the same origin.
        Remove origin links to create an independent copy of this device.`,
    projectLevelAlreadyHasSubsystem: `Project level already has a subsystem referenced to the same origin.
        Remove origin links to create an independent copy of this subsystem.`,
    projects: "Projects",
    projectCompliantItemsPerSet: "Project Compliant Items per Set",
    projectDescription: "Project Description",
    projectDevice: "Project Device",
    projectDevices: "Project Devices",
    projectFolderNotEmpty: "Project folder is not empty. Project can not be removed",
    productFolderNotEmpty: "Product folder is not empty. Product can not be removed",
    projectGroups: "Project Groups",
    projectId: "Project ID",
    projectModuleAccess: "Project Module Access",
    projectPublicId: "Project Public ID",
    projectSettings: "Project Settings",
    projectSubsystems: "Project Subsystems",
    projectTeamMembers: "Project Team Members",
    provenInUse: "Proven in Use",
    provenReliabilityData: "Proven reliability data",
    pt: "Portuguese",
    ptc0A: "PTC 0, A",
    ptc1A: "PTC 1, A",
    ptc0B: "PTC 0, B",
    ptc1B: "PTC 1, B",
    ptc0C: "PTC 0, C",
    ptc1C: "PTC 1, C",
    public: "Public",
    publicationDate: "Publication Date",
    publicId: "Public ID",
    published: "Published",
    qidCalculationMethod: "QID Calculation Method",
    qidDeviceUpdated: `The QID Device was updated.
        Click {0} if you wish to review the difference(s) between the QID Device and the Project Device.`,
    qidMasterAccess: "QID Master Access",
    qidProducts: "QID Products",
    recalculationDescription: "Updating this device will recalculate {0} safety function(s). It will cost 1 calculation.",
    recalculationTitle: "Recalculation required",
    recentFiles: "Recent Files",
    recycle: "Recycle",
    recycleBin: "Recycle Bin",
    redistributions: "Redistributions",
    reference: "Reference",
    registrationError: "Unhandled error! Registration process can not be finished. Please, contact with the Administrator",
    registrationFinished: "Registration Is Finished",
    registrationCompanyAccountCreated: "Your company account \"{COMPANY}\" has been created.",
    registrationUserAdministratorOfAccount: "You, {USER} with email {EMAIL} are the administrator of this company account.",
    rename: "Rename",
    renameRevision: "Rename Revision",
    renameSet: "Rename Set",
    remark: "Remark",
    remindMeLater: "Remind me later",
    remove: "Remove",
    removeFromText: "Remove from text",
    removeOriginLinks: "Remove origin links",
    repeat: "Repeat",
    repeatNewPassword: "Repeat New Password",
    report: "Report",
    reportLanguage: "Report Language:",
    reportCopyright: "All Rights Reserved",
    reporting: "Reporting",
    reports: "Reports",
    reportNotificationCompliance: "Important! Reports will use the current selected revision of answers.",
    reportNotificationMain: "Important! CC module reports will use the last revision of answers.",
    reportNumber: "Report Number",
    requirements: "Requirements",
    requirementsOverview: "Requirements Overview",
    requirementsReport: "The following requirements are a part of this project:",
    requirementsReview: "Requirements Review",
    requirementsSettings: "Requirements Settings",
    requirementsModuleAccess: "Requirements Module Access",
    requirementsPriority: "Requirements Priority",
    requirementsReviewMethod: "Requirements Review Method",
    requirementsSmartCompliance: "Requirements SMART Compliance",
    requirementsStatus: "Requirements Status",
    requirementsType: "Requirements Type",
    rerun: "Rerun",
    rerunAll: "Rerun All",
    rerunAllDescription: "Copy all previous answers and set all back to responsible",
    rerunNoneCompliantItems: "Rerun None Compliant Items",
    rerunNoneCompliantItemsDescription: "Copy all previous answers, but only set back all to responsible for those that are not compliant",
    resetPassword: "Reset Password",
    response: "Response",
    responses: "Responses",
    responseModuleAccess: "Response Module Access",
    responsible: "Responsible",
    responsibleAnswer: "Responsible Answer",
    restore: "Restore",
    result: "Result",
    results: "Results",
    resultsPDF: "Results PDF",
    resume: "Resume",
    returnForRevision: "Return For Revision",
    returnToLevel: "Return To {level}",
    reverse: "Reverse",
    review: "Review",
    reviewCompliance: "Review Compliance",
    reviewItem: "Review Item",
    reviewItemDescription: "has the following remark concerning document",
    reviewMethod: "Review Method",
    reviewMethods: "Review Methods",
    reviewReview: "Review Review",
    reviewRevision: "Review Revision",
    reviewSettings: "Review Settings",
    reviewStatus: "Review Status",
    revision: "Revision",
    revisionHistory: "Revision History",
    revisionList: "Revision List",
    reviewStatistics: "Review Statistics",
    riskMap: "Risk Map",
    riskMapGenerated: "Risk Map Generated",
    risknowlogy: "Risknowlogy",
    riskSpace: "Risk Space",
    riskSpaceModuleAccess: "Risk Space Module Access",
    riskSpaceTemplates: "Risk Space Templates",
    rrsEngine: "RRS Engine",
    ru: "Russian",
    safeFailures: "Safe Failures",
    safeSystematicFailure: "Safe Systematic Failure",
    safetyDetails: "Functional Safety Details",
    safetyFunction: "Safety Function",
    safetyFunctionDescription: "Safety Function Description",
    safetyFunctionNotCalculated: "This function is not calculated",
    safetyFunctionParameters: "Safety Function Parameters",
    safetyFunctions: "Safety Functions",
    safetyFunctionSettings: "Safety Function Settings",
    safetyFunctionsReport: "The following safety functions are a part of this project:",
    safetyFunctionUpdated: `Functional Safety data was updated.
        Click {0} if you wish to review the changes and recalculate safety function.`,
    save: "Save",
    scientific: "Scientific",
    scribe: "Scribe",
    sd: "SD",
    sdOf: "SD of",
    search: "Search",
    searchPlaceholder: "Search",
    searchWithFilterPlaceholder: "Filter and search",
    searchWithActiveFilterPlaceholder: "search",
    seePage: "See",
    seconds: "Seconds",
    secretKey: "Secret Key",
    secretKeyRepeat: "Repeat Secret Key",
    select: "Select",
    selected: "Selected",
    selectAccount: "Select Account",
    selectAccountGroup_s: "Select Account Group(s)",
    selectAll: "Select All",
    selectCategories: "Select Categories",
    selectColumns: "Select Columns",
    selectDevice: "Select Device",
    selectElement: "Select element...",
    selectFile: "Select File",
    selectFiles: "Select Files",
    selectFromDrive: "Select From Drive",
    selectGroup: "Select Group",
    selectGroup_s: "Select Group(s)",
    selectLevel: "Select Level",
    selectModel: "Select Model",
    selectModulesForReport: "Select modules for report",
    selectOption: "Select Option",
    selectPackage: "Select Package",
    selectProjectGroup_s: "Select Project Group(s)",
    selectReference: "Select Reference",
    selectRequirement_s: "Select Requirement(s)",
    selectSafetyFunction: "Select Safety Function",
    selectState_s: "Select State(s)",
    selectUploadStorage: "Select Upload Storage",
    selectUser: "Select User",
    selectUser_s: "Select User(s)",
    send: "Send",
    session: "Session",
    sessionFields: "Session Fields",
    sessions: "Sessions",
    setNewPassword: "Set New Password",
    setPassword: "Set Password",
    setPasswordToFinishRegistration: "Please, set a password to finish registration",
    settings: "Settings",
    s_f: "S_F",
    sff: "SFF",
    sffCalculated: "The calculated SFF based on the given failure rates is",
    sffGiven: "SFF given",
    sffOf: "SFF of",
    shortName: "Short Name",
    shouldDecreaseTo: "Should decrease to",
    shouldIncreaseTo: "Should increase to",
    shouldStayAbove: "Should stay above",
    shouldStayBelow: "Should stay below",
    showArchivedSessions: "Show archived sessions",
    showPrevious: "Show Previous",
    signIn: "Sign In",
    signOut: "Sign Out",
    signUp: "Sign Up",
    sil: "SIL",
    sil_1: "SIL 1",
    sil_2: "SIL 2",
    sil_3: "SIL 3",
    sil_4: "SIL 4",
    sil_1_1: "SIL 1 Capable according to route 1",
    sil_2_1: "SIL 2 Capable according to route 1",
    sil_3_1: "SIL 3 Capable according to route 1",
    sil_4_1: "SIL 4 Capable according to route 1",
    sil_1_2: "SIL 1 Capable according to route 2",
    sil_2_2: "SIL 2 Capable according to route 2",
    sil_3_2: "SIL 3 Capable according to route 2",
    sil_4_2: "SIL 4 Capable according to route 2",
    silArchitecture: "SIL Architecture",
    silBasedOnArchitecture: "SIL based on Architecture",
    silBasedOnPfd: "SIL based on PFDavg",
    silBasedOnPfh: "SIL based on PFH",
    silCalculationReport: "SIL Hardware Integrity Verification Report",
    silOf: "SIL of",
    silMasterAccess: "SIL Master Access",
    simplifiedEquationsIec_61508_2010: "Simplified equations as presented in IEC 61508:2010",
    simplifiedEquationsIec_61508_1998: "Simplified equations as presented in IEC 61508:1998",
    simplifiedEquationsIsa_tr84_2002: "Simplified equations as presented in ISA TR84:2002",
    simplifiedEquationsIsa_tr84_2022: "Simplified equations as presented in ISA TR84:2022",
    simplifiedEquationsVdi_vde_2180_2019: "Simplified equations as presented in VDI/VDE 2180:2019",
    since: "since",
    singleRiskMap: "Single Risk Map",
    site: "Site",
    size: "Size",
    smartCompliance: "Smart Compliance",
    smartCompliances: "Smart Compliances",
    softDeadline: "Soft deadline",
    source: "Source",
    specific_date: "Specific date",
    spiral_model: "Spiral model",
    sql: "SQL",
    sqlExecutor: "_sqlExecutor_",
    start: "Start",
    startFreeTrial: "Start Free Trial",
    startTime: "Start Time",
    startTimeLessEndTime: "Start Time must be less than End Time",
    startvectors: "Start Vectors",
    state: "State",
    stateFrom: "State From",
    states: "States",
    statesFrom: "States From",
    statesTo: "States To",
    stateTo: "State To",
    status: "Status",
    stlLevel: "STL {0}",
    stlLevelBasedOnStr: "STL based on STR",
    stlLevels: "STL Levels",
    storage: "Storage",
    str: "STR",
    stripe: "Stripe",
    stripeOrder: "Stripe Order",
    strTargetIsMet: "STR Target {0} is met",
    strTargetIsNotMet: "STR Target {0} is not met",
    studies: "Studies",
    study: "Study",
    studyFields: "Study Fields",
    studyModuleAccess: "Study Module Access",
    studyStatus: "Study Status",
    su: "SU",
    suOf: "SU of",
    subject: "Subject",
    subLifecycles: "Sub Lifecycles",
    submit: "Submit",
    subProjects: "Sub Projects",
    subscriptionExpires: "Your subscription expires on {0}",
    subscriptionExpiresDescription: "Your subscription is almost expired. Please, contact us to renew your package on time.",
    subscriptionExpired: "Your subscription expired on {0}",
    subscriptionExpiredDescription: "Your subscription has expired. Please, contact us to renew your package.",
    subsystem: "Subsystem",
    subsystemArchitectureParameters: "Subsystem Architecture Parameters",
    subsystemCantBeSaved: "This subsystem cannot be saved. Please select a different combination of devices",
    subsystemData: "Subsystem Data",
    subsystemModelCantBeUpdated: "This subsystem model cannot be updated. Wrong device combination",
    subsystemParameters: "Subsystem Parameters",
    subsystems: "Subsystems",
    subsystemUpdated: "Devices in the Subsystem have been changed. Click {0} if you wish to review the difference(s).",
    subTaskModuleAccess: "Sub Task Module Access",
    subTasks: "Subtasks",
    subUnit: "Sub Unit",
    successfullyRegistered: "Successfully Registered!",
    supposedly_completed: "Supposedly Completed",
    symbol: "Symbol",
    systemStage: "System Stage",
    t0: "T0",
    t1: "T1",
    t2: "T2",
    tableOfContents: "Table of Contents",
    tags: "Tags",
    target: "Target",
    targetNumber: "Target Number",
    targetNumberDescription: "The target number represents what you want to achieve.",
    targetPfd: "Target PFDavg",
    targetPfh: "Target PFH",
    targetSil: "Target SIL",
    targetSilAchieved: "Target {0} is achieved for this hardware",
    targetSilLevel: "Target SIL level",
    targetSilNotAchieved: "Target {0} is not achieved for this hardware",
    targetStl: "Target STL",
    targetStlAchieved: "Target STL {0} is achieved for this hardware",
    targetStlLevel: "Target STL Level",
    targetStlNotAchieved: "Target STL {0} is not achieved for this hardware",
    targetStlPercents: "% STL {0} Target",
    targetStr: "Target STR",
    task: "Task",
    tasks: "Tasks",
    taskModuleAccess: "Task Module Access",
    taskGrantView: "Task Grant View",
    taskKanbanView: "Task Kanban View",
    taskOverdue: "Task is overdue!",
    team: "Team",
    teamMembers: "Team Members",
    teamMembersFields: "Team Members Fields",
    template: "Template",
    templates: "Templates",
    templateMinNumberOfLabels: "Required number of labels for matrix - 2.",
    templateNumberOfLabelsWithCategory: "Required number of labels with category assigned - 1.",
    templateLabelNestedCategoriesRequired: "Label '{0}' requires nested categories.",
    templateLabelNestedCategoryLevelsRequired: "Category '{0}' of Label '{1}' requires levels.",
    templateLabelNestedCategoriesLevelNumber: "Label '{0}' requires the same number of levels in each category.",
    templateLabelLevelsRequired: "Label '{0}' requires levels.",
    testImageToUpload: "Test image to upload",
    text: "Text",
    thanksForConfirmingEmail: "Thank you for confirming email",
    thanksForRegistration: "Thank you for your registration",
    this_month: "This month",
    this_week: "This week",
    thisDeviceIs: "This device is: ",
    thisLink: "this link",
    thursday: "Thursday",
    ti: "TI",
    time: "Time",
    timeframe: "Timeframe",
    timeRequired: "Time required",
    timezone: "Time Zone",
    title: "Title",
    toBeAdded: "To be added",
    toBeCalculatedSafetyFunctions: "To Be Calculated Safety Function(s)",
    today: "Today",
    toDelete: "To Delete",
    tomorrow: "Tomorrow",
    topLevel: "Top Level",
    total: "Total",
    transitions: "Transitions",
    translations: "Translations",
    treeAlignment: "Tree Alignment",
    tuesday: "Tuesday",
    type: "Type",
    uniqueId: "Unique ID",
    unit: "Unit",
    unitDesription: `The unit represents how your KR is accounted and expressed. If a unit does not exist in the drop-down menu,
        you can create a custom one, such as CHF or page visits.
    `,
    unlimited: "Unlimited",
    unlimitedCalculations: "You have unlimited calculations.",
    unlimitedCalculationsHeader: "Unlimited SIL calculations.",
    unmark: "Unmark",
    unpublished: "Unpublished",
    update: "Update",
    updateAll: "Update All",
    updated: "Updated",
    updatedSubsystem: "Updated Subsystem",
    updateKeyResult: "Update Key Result",
    updateModel: "Update Model",
    updatePostedOn: "This update was posted on {0}",
    updateResponse: "Update Response",
    upgrade: "Upgrade",
    upload: "Upload",
    uploaded: "Uploaded",
    uploadError: "Upload Error",
    url: "Url",
    use: "Use",
    useCriticalTarget: "Use additional critical target",
    usedCalculations: "Used Calculations",
    user: "User",
    users: "Users",
    userNotFound: "User Is Not Found",
    userNotFoundDescription: "Sorry, this link is not available any more",
    userWithEmailExists: "User with this email already exists",
    userWithLoginExists: "User with this login already exists",
    usernamePlaceholder: "username or email",
    userUpdatedTheValue: "{0} updated the value to {1}",
    validationExpression: "System cannot execute this",
    validationExpressionRecursive: "Recursive links in the expression",
    validationFieldRequired: "This field is required",
    validationLinkToItselfOrNested: "Cannot link node to itself or its nested",
    validationNumberRequired: "Field of type 'Number' required",
    validationMaxLength: "Field length must be less or equal to {0}",
    validationNotUnique: "Field must be unique",
    validationValueBetween: "Please enter a value between {0} and {1}.",
    validationValueRequired: "Please enter a value",
    validationVersions: "Check attached files - some files were removed",
    validationUnknown: "Unknown error",
    validationWrongUrl: "Wrong URL",
    value: "Value",
    variable: "Variable",
    variables: "Variables",
    vdi_vde_2180_2019: "VDI/VDE 2180:2019 beta",
    verification: "To be checked",
    version: "Version",
    versions: "Versions",
    view: "View",
    viewAccount: "View Account",
    viewCalculationAssumptions: "View Calculation Assumptions",
    viewCompany: "View Company",
    viewComplianceSet: "View Compliance Set",
    viewCompliantItem: "View Compliant Item",
    viewDevice: "View Device",
    viewGroup: "View Group",
    viewHelp: "View Help",
    viewLifecycle: "View Life Cycle",
    viewMethod: "View Method",
    viewModel: "View Model",
    viewModule: "View Module",
    viewPriority: "View Priority",
    viewProduct: "View Product",
    viewRequirement: "View Requirement",
    viewRevision: "View Revision",
    viewSafetyFunction: "View Safety Function",
    viewSession: "View Session",
    viewSmartCompliance: "View Smart Compliance",
    viewStatus: "View Status",
    viewStudy: "View Study",
    viewSubsystem: "View Subsystem",
    viewTeamMember: "View Team Member",
    viewTemplate: "View Template",
    viewType: "View Type",
    viewUser: "View User",
    visibility: "Visibility",
    v_model: "V model",
    warning: "Warning",
    waterfall: "Waterfall",
    weekly: "Weekly",
    weeks: "weeks",
    wednesday: "Wednesday",
    workflowLevelAssigned: "{level} assigned",
    workflowRerun: "Rerun the item",
    workflowReturnToLevel: "Return to {level}",
    workflowSendToLevel: "Send to {level}",
    workflowApproved: "Compliant Item approved",
    workflowNotApproved: "Compliant Item not approved",
    wrongConfigFormatting: "Current config has wrong formatting",
    wt: "WT",
    xDayOfMonth: "{0} day of the month",
    xDayOfMonthWarning: "Some months don't have 29, 30 or 31 days.",
    years: "years",
    yes: "Yes",
    yes_no: "Yes/No",
    yesterday: "Yesterday",
}
